import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=09ea1529"
import script from "./payroll.vue?vue&type=script&lang=js"
export * from "./payroll.vue?vue&type=script&lang=js"
import style0 from "./payroll.vue?vue&type=style&index=0&id=09ea1529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports